import { addFilter } from '@wordpress/hooks/build-types';
import '../scss/blocks.scss';

/**
 * Blocks für Inhaltsseiten
 *
 * @package SSV Reutlingen
 */

import './gutenberg/blocks/divider-heading';
import './gutenberg/blocks/image';
import './gutenberg/blocks/table';
import './gutenberg/blocks/text-default';
import './gutenberg/blocks/text-image';
import './gutenberg/blocks/text-column-4';
import './gutenberg/blocks/text-column-5';
import './gutenberg/blocks/text-middle';
 